<script>
  import { page } from '$app/stores';
  import { Graphic, Text, Meta, PrimaryText, SecondaryText } from '@smui/list';
  import Stars from '$lib/client/shared/stars.svelte';
  import Chip, { Set, TrailingAction, Text as ChipText } from '@smui/chips';
  import noImage from '$assets/no-artwork-grey-100x100.png';
  import Badge from '@smui-extra/badge';

  import NextOnChannel from '$lib/client/shared/next-on-channel.svelte';

  export let track;
  export let artist;
  export let showBadges = false;
  const { scheduled_at, channel } = track?.next_on || {};
</script>


<Graphic class="u-m-none">
    {#if track.badges && showBadges}
        {#each track.badges as badge}
            <Badge
                color={badge.name}
                aria-label={badge.title}
                title={badge.title}
                position="inset"
                align="top-start">{badge.label}</Badge
                                               >
        {/each}
    {/if}

    <img loading="lazy" src={track.images ? track.images.thumbnail : noImage} alt={track.title} />
</Graphic>

<Text>

    <PrimaryText class="t-uppercase">
        {track.title}
    </PrimaryText>

    <SecondaryText>
        By
        {#if $page.url.pathname !== `/artists/${artist.slug}`}
            <a href="/artists/{artist.slug}" class="link link--secondary"
            ><span class="t-uppercase">{artist.name}</span></a
                                                           >
        {:else}
            <span class="t-uppercase">{artist.name}</span>
        {/if}
    </SecondaryText>

    {#if track.genres?.length}
        <div class="genres">
            <SecondaryText>
                {track.genres.map((g) => g.name).join(', ')}
            </SecondaryText>
        </div>
    {/if}

    {#if scheduled_at}
        <SecondaryText class="t-uppercase">
            <NextOnChannel {scheduled_at} {channel} />
        </SecondaryText>
    {/if}
</Text>

<Meta>
  <Stars stars={track.total_rating} />
  <slot name="meta" />
</Meta>
